module.exports = __webpack_public_path__ + "img/illustration-reset-password-light.fc74aea2.png";